module.exports = __webpack_public_path__ + "images/background-red-2-db1574c765bead52b4ed81c5c72796d8.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/background-red-2.svg
// module id = 6
// module chunks = 0